import keyBy from 'lodash/keyBy';
import filter from 'lodash/filter';
import {getRootStore} from '../../app.bootstrap';

// One day, in msec
const MAX_STATE_AGE = 86400000;

export interface WizardState {
    roomId: string;
    timestamp: number;
    showWizard: boolean;
    step: number;
    platform: string | null;
}

interface WizardStates {
    [roomId: string]: WizardState;
}

/**
 * Helper service for the wizard state.
 * Initializes, deletes, cleans up states
 */
export interface ITsWizardHelperService {
    getState(roomId: string): WizardState;
    newState(roomId: string): WizardState;
    removeState(state: WizardState): void;
}

export class TsWizardHelperService implements ITsWizardHelperService {
    private browserUtilsService: any;

    constructor() {
        this.browserUtilsService = getRootStore().browserUtilsService;

        if (!this.browserUtilsService.getFromLocalStorage('wizardStates')) {
            this.browserUtilsService.saveToLocalStorage('wizardStates', {});
        }

        // on startup we clean up old states that might have not ended normally
        this.cleanUpOldStates();
    }

    public getState(roomId: string): WizardState {
        const states = this.browserUtilsService.getFromLocalStorage('wizardStates') as WizardStates;

        return states[roomId] || this.newState(roomId);
    }

    public newState(roomId: string): WizardState {
        const wizardStates = (this.browserUtilsService.getFromLocalStorage('wizardStates') as WizardStates) || {};

        wizardStates[roomId] = {
            roomId: roomId,
            timestamp: Date.now(),
            showWizard: true,
            step: 0,
            platform: null
        };

        this.browserUtilsService.saveToLocalStorage('wizardStates', wizardStates);
        return wizardStates[roomId];
    }

    public removeState(state: WizardState): void {
        const wizardStates = (this.browserUtilsService.getFromLocalStorage('wizardStates') as WizardStates) || {};
        delete wizardStates[state.roomId];
        this.browserUtilsService.saveToLocalStorage('wizardStates', wizardStates);
        this.browserUtilsService.removeFromLocalStorage('current-session');
    }

    private cleanUpOldStates(): void {
        const now = Date.now();
        const wizardStates = (this.browserUtilsService.getFromLocalStorage('wizardStates') as WizardStates) || {};

        const filteredStates = keyBy(
            filter(wizardStates, (state) => now <= state.timestamp + MAX_STATE_AGE),
            'roomId'
        );

        this.browserUtilsService.saveToLocalStorage('wizardStates', filteredStates);
    }
}
